import { all } from 'redux-saga/effects';

import consultaMudancaCategoriaSaga from './consultaMudancaCategoria/saga';
import gerarRenachSaga from './gerarRenach/saga';

export const consultaMudancaCategoria = consultaMudancaCategoriaSaga;

export default all([consultaMudancaCategoriaSaga, gerarRenachSaga]);
